import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

declare let d3

import { Speaker } from '../models/speaker';
import { SpeakerService } from '../speaker.service';
import ErrorBarsPlugin from 'chartjs-plugin-error-bars';


@Component({
  selector: 'scatter',
  /* template: `
   <button type="button" class="btn btn-primary" (click)="speakerSrv.changeView('RES', $event)"><i class="fa fa-chevron-left" aria-hidden="true"></i>
 Back</button>
   <div>
     <nvd3 [options]='options' [data]='data'></nvd3>
   </div>`,*/
  templateUrl: './scatter.component.html',
  styleUrls: ['./scatter.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ScatterChartComponent implements OnInit {
  @ViewChild('scatter') scatter: ElementRef;
  options;
  data;

  genderKeys = ['m', 'f'];

  plotData;

  barColors: any[];

  constructor(private speakerSrv: SpeakerService) { }

  public barChartLabels: string[] = [];

  public Male1994 = 0;
  public Female1994 = 0;
  public Male2014 = 0;
  public Female2014 = 0;
  public male1994Count = 0;
  public female1994Count = 0;
  public male2014Count = 0;
  public female2014Count = 0;
  public male1994Absolute = 0;
  public female1994Absolute = 0;
  public male2014Absolute = 0;
  public female2014Absolute = 0;

  public labels: string[] = ["Male", "Female"];

  ngOnInit() {
    this.options = {
      legend: {
        onClick: (e) => e.stopPropagation()
      },
      plugins: {
        chartJsPluginErrorBars: {
          color: 'rgba(0, 0, 0, 0.1)',
          width: '5%'
        }
      },
      plugin: [ErrorBarsPlugin],
      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              max: 0,
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Relative Frequency per 10,000'
            }
          }
        ]
      }
    };

    this.speakerSrv.statsChange.subscribe(stats => { this.update(stats); });

    this.options.tooltips =
    {
      enabled: true,
      mode: 'single',
      displayColors: false,
      callbacks: {
        label: function (tooltipItem, data) {
          //let label = data.labels[tooltipItem.index];
          let datasetLabel = Number(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
          let count = Number(data.datasets[tooltipItem.datasetIndex].counts[tooltipItem.index]);
          if (datasetLabel != 0) {
            let i = 2;
            while (Number(d3.format(',.0' + i + 'f')(datasetLabel).replace(",", "")) == 0) {
              i++;
            }
            return d3.format(',.0' + i + 'f')(datasetLabel) + " (" + count + ")";
          }
          return d3.format(',.02f')(datasetLabel) + " (" + count + ")";
        }
      }
    };
    this.barColors = [];

    let ctx = this.scatter.nativeElement.getContext('2d');
    let grad1 = ctx.createLinearGradient(0, 0, 0, 200);
    grad1.addColorStop(0, 'rgb(105,130,231)');
    grad1.addColorStop(1, 'rgb(125,222,238)');

    let grad2 = ctx.createLinearGradient(0, 0, 0, 200);
    grad2.addColorStop(0, 'rgb(233,105,210)');
    grad2.addColorStop(1, 'rgb(247,126,151)');

    this.barColors.push({ backgroundColor: grad1, hoverBackgroundColor: grad1 });
    this.barColors.push({ backgroundColor: grad2, hoverBackgroundColor: grad2 });
  }

  getStandardDeviation(array) {
    const n = array.length

    if (n == 0)
      return 0;

    const mean = array.reduce((a, b) => a + b) / n
    return Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n ** 2)
  }

  roundUp(value) {
    let multiplier = Math.pow(10, Math.floor(Math.log10(value)));
    return Math.ceil(value / multiplier) * multiplier;
  }

  update(stats) {
    this.Male1994 = 0;
    this.Female1994 = 0;
    this.Male2014 = 0;
    this.Female2014 = 0;
    this.male1994Count = 0;
    this.female1994Count = 0;
    this.male2014Count = 0;
    this.female2014Count = 0;
    this.male1994Absolute = 0;
    this.female1994Absolute = 0;
    this.male2014Absolute = 0;
    this.female2014Absolute = 0;

    let deviations = [[], [], [], []];

    let data = { labels: ['1994', '2014'] };
    // If array is not empty
    if (Object.keys(stats).length > 0) {

      let keys = this.genderKeys;

      // Create an object that has the total value of all the keys added together
      var obj = keys.reduce(function (acc, cur, i) {
        acc[cur] = 0;
        return acc;
      }, {});

      // Assign Corpus Total Dictionary to categorise data.
      let corpusTotal = { '1994': Object.assign({}, obj), '2014': Object.assign({}, obj) };

      //for each dataset
      for (let i = data.labels.length - 1; i >= 0; i--) {

        let l = data.labels[i];

        const objKeys = Object.keys(stats[l]);

        // for each entry
        for (let j = objKeys.length - 1; j >= 0; j--) {
          let g = stats[l][objKeys[j]];

          //       console.log(g);

          if (g['gender'] == 'male' && i == 1) {
            deviations[0].push(g['relative']);
            this.Male2014 = this.Male2014 + g['relative'];
            this.male2014Count = this.male2014Count + 1;
            this.male2014Absolute = this.male2014Absolute + g['count'];
            //      console.log('M14');
          } else if (g['gender'] == 'female' && i == 1) {
            deviations[1].push(g['relative']);
            this.Female2014 = this.Female2014 + g['relative'];
            this.female2014Count = this.female2014Count + 1;
            this.female2014Absolute = this.female2014Absolute + g['count'];
            //      console.log('F14');
          } else if (g['gender'] == 'male' && i == 0) {
            deviations[2].push(g['relative']);
            this.Male1994 = this.Male1994 + g['relative'];
            this.male1994Count = this.male1994Count + 1;
            this.male1994Absolute = this.male1994Absolute + g['count'];
            //      console.log('M94');
          } else if (g['gender'] == 'female' && i == 0) {
            deviations[3].push(g['relative']);
            this.Female1994 = this.Female1994 + g['relative'];
            this.female1994Count = this.female1994Count + 1;
            this.female1994Absolute = this.female1994Absolute + g['count'];
            //           console.log('F94');
          }
        }
      }

    }
    this.Male1994 = (this.Male1994 / this.male1994Count);
    this.Female1994 = this.Female1994 / this.female1994Count;
    this.Male2014 = this.Male2014 / this.male2014Count;
    this.Female2014 = this.Female2014 / this.female2014Count;
    this.data = [
      {
        errorBars: { Male: { plus: this.getStandardDeviation(deviations[2]), minus: -this.getStandardDeviation(deviations[2]) }, Female: { plus: this.getStandardDeviation(deviations[3]), minus: -this.getStandardDeviation(deviations[3]) } },
        counts: [this.male1994Absolute, this.female1994Absolute],
        data: [this.Male1994, this.Female1994],
        label: '1994'
      },
      //backgroundColor: ["#c47eee", "#e86dd0"]},
      {
        errorBars: { Male: { plus: this.getStandardDeviation(deviations[0]), minus: -this.getStandardDeviation(deviations[0]) }, Female: { plus: this.getStandardDeviation(deviations[1]), minus: -this.getStandardDeviation(deviations[1]) } },
        counts: [this.male2014Absolute, this.female2014Absolute],
        data: [this.Male2014, this.Female2014],
        label: '2014'//,
        //      backgroundColor: ["#d3f77f", "#eac26c"]//"rgb(255, 127, 14)"
      }
    ];


    for (let i = 0; i < 4; i++) {
      let standard_deviation = this.getStandardDeviation(deviations[i]);

      let value = 0;

      if (i == 0)
        value = this.Male2014;
      else if (i == 1)
        value = this.Female2014;
      else if (i == 2)
        value = this.Male1994;
      else if (i == 3)
        value = this.Female1994;

      let max_value = this.roundUp(value + standard_deviation)

      if (max_value > this.options.scales.yAxes[0].ticks.max)
        this.options.scales.yAxes[0].ticks.max = max_value;
    }
  }

  chartClicked(event: any) {
    console.log(event);
    if (event.active.length > 0) {
      let chartElement = event.active[0]._chart.getElementAtEvent(event.event);
      console.log(chartElement[0]._model.datasetLabel);
      let newEvent = {
        element: {
          _model: {
            datasetLabel: chartElement[0]._model.datasetLabel,
            label: chartElement[0]._model.label
          }
        }
      };
      this.speakerSrv.changeView('Concordance', event);
      this.speakerSrv.concordanceGenderFilter.next(newEvent);
    }
  }

}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/scatter/scatter.component.ts